import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { CUSTOM_ROUTE_DESKTOP_MAP } from '../config/constants';
import { CustomRouteDesktopViews } from '../interfaces/custom-route-desktop.interface';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class CustomRouteDesktopViewStateService {
  private _sessiongStorageService = inject(SessionStorageService);

  public desktopViewsState: WritableSignal<CustomRouteDesktopViews> = signal(CUSTOM_ROUTE_DESKTOP_MAP.map);
  public isSidebarCollapsed: WritableSignal<boolean> = signal(false);

  setDesktopViewsState(view: CustomRouteDesktopViews): void {
    this.desktopViewsState.set(view);
    this._sessiongStorageService.setItem('customRouteDesktopViewsState', view);
  }
}
